// Added by Jonghyung Lee on 2021-02-01
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GetQueryReturn } from '@/helper/define'
import { getQueryString } from '@/helper/util'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { HL7ElementProps, HL7TaskInfoProps, HL7TaskProps } from '@/helper/define/hl7Define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetHL7List = async (path: string = '') => {
  return await axios.get<GetQueryReturn<HL7ElementProps>>(`/v1/mgmt/hl7/orms?${path}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetHL7 = async (id: string) => {
  return await axios.get<HL7ElementProps>(`/v1/mgmt/hl7/orms/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResCreateHL7Props extends HL7ElementProps {}

export const reqCreateHL7 = async (elements: HL7ElementProps) => {
  return await axios.post<ResCreateHL7Props>(`/v1/mgmt/hl7/orms`, { ...elements })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqDeleteHL7 = async (id: string) => {
  return await axios.delete(`/v1/mgmt/hl7/orms/${id}`)
}

interface IReqConnectionCheck {
  oru_peer_ip_address: string
  oru_peer_port: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqConnectionCheck = async (address: IReqConnectionCheck) => {
  return await axios.post('/v1/mgmt/hl7/orus:connection-check', { ...address })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUpdateHL7Props extends HL7ElementProps {}
export const reqUpdateHL7 = async (id: string, elements: HL7ElementProps) => {
  return await axios.put<ResUpdateHL7Props>(`/v1/mgmt/hl7/orms/${id}`, {
    ...elements,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// for monitoring UI
interface ResGetHL7JobLists {
  items: HL7TaskProps[]
  total_count: string
}

/** Tasks 정보만 가져옴: List에서 보여주는 용도 */
export const reqGetHL7JobLists = async (query: any) => {
  const queryStr = getQueryString<any>(query)
  return await axios.get<ResGetHL7JobLists>(`/v1/mgmt/hl7/tasks${queryStr}`)
}

/** 상세 정보를 가져옴 Dialog에서 보여주는 용도 */
export const reqGetHL7Job = async (id: string) => {
  return await axios.get<HL7TaskInfoProps>(`/v1/mgmt/hl7/tasks/${id}`)
}

export const reqCancelHL7Job = async (id: string) => {
  return await axios.post(`/v1/mgmt/hl7/tasks:cancel`, { id })
}

export const reqGetStorageList = async () => {
  return await axios.get(`/v1/mgmt/hl7/tasks-all/datastorages`)
}

// hl7 status 정보를 모두 가져옴.
export const getAllHL7Status = async () => {
  return await axios.get(`/v1/mgmt/hl7/status-all`)
}

// 재시작
export const reqRestartHL7Tasks = async (ids: string[]) => {
  return await axios.post(`/v1/mgmt/hl7/tasks:restart`, { ids })
}

// start가 가능한 task 목록을 가져옴 
export const getHL7RestartAbleTasks = async (query: any) => {
  const queryStr = getQueryString<any>(query)
  return await axios.get(`/v1/mgmt/hl7/tasks:restart${queryStr}`)
}

